module.exports = __webpack_public_path__ + "img/calc.97488eed.png";